import Svg, { ClipPath, Defs, G, LinearGradient, Path, Stop } from 'react-native-svg';
import { IllustrationProps } from '../Illustration';

export const SpinnerSvg = ({ width = '100%', height = '100%', ref, testID }: IllustrationProps) => {
  return (
    <Svg width={width} height={height} ref={ref} testID={testID} viewBox="0 0 58 58" fill="none">
      <Defs>
        <ClipPath id="clip">
          <Path
            d="M0.995 21.831
            C5.139 6.123 21.037 -3.198 36.504 1.011
            C51.970 5.219 61.149 21.365 57.005 37.073
            L51.124 35.472
            C54.397 23.063 47.146 10.308 34.927 6.983
            C22.709 3.659 10.150 11.023 6.876 23.433
            C3.602 35.842 10.854 48.596 23.073 51.921
            C24.696 52.364 25.660 54.059 25.225 55.708
            C24.790 57.357 23.120 58.336 21.496 57.894
            C6.030 53.685 -3.149 37.539 0.995 21.831Z"
          />
        </ClipPath>

        {/* Approximated linear gradient instead of conic */}
        <LinearGradient id="grad" x1="0" y1="0" x2="1" y2="1" gradientUnits="objectBoundingBox">
          <Stop offset="0.5" stopColor="rgba(0, 162, 171, 1)" />
          <Stop offset="0.74" stopColor="rgba(0, 162, 171, 0)" />
        </LinearGradient>
      </Defs>

      <G clipPath="url(#clip)" opacity={1}>
        <Path
          d="M0.995 21.831
            C5.139 6.123 21.037 -3.198 36.504 1.011
            C51.970 5.219 61.149 21.365 57.005 37.073
            L51.124 35.472
            C54.397 23.063 47.146 10.308 34.927 6.983
            C22.709 3.659 10.150 11.023 6.876 23.433
            C3.602 35.842 10.854 48.596 23.073 51.921
            C24.696 52.364 25.660 54.059 25.225 55.708
            C24.790 57.357 23.120 58.336 21.496 57.894
            C6.030 53.685 -3.149 37.539 0.995 21.831Z"
          fill="url(#grad)"
        />
      </G>
    </Svg>
  );
};
